<template>
	<section
		class="standard_header"
		:style="{'--content-bg-pos': image_position ? image_position : 'center', '--quick-links-height': quick_links_height - (window.width < 1280 ? 30 : 0) + 'px', '--quick-links-height-neg': (quick_links_height * -1) + 113 + 'px', '--background-image': parsedImage.url ? 'url(' + parsedImage.url + ')' : false}"
	>
		<div class="container">

			<div class="inner">
				<slot name="breadcrumbs"></slot>

				<h1
					:data-highlightword="getWordsInFirstRow(title)"
					v-html="title"
				></h1>
				<div
					class="body"
					v-html="description"
				></div>
			</div>

		</div>

	</section>
</template>

<script>
export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			quick_links_height: {},
		};
	},

	props: {
		title: {},
		description: {},
		image: {},
		image_position: {},
		quick_links: {},
	},

	computed: {
		parsedImage() {
			if (this.image) {
				return JSON.parse(this.image);
			} else {
				return null;
			}
		},

		parsedQuickLinks() {
			if (this.quick_links) {
				return JSON.parse(this.quick_links);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.getQuickLinksHeight();
		},

		handleAccordionToggle(isOpen) {
			console.log('Accordion state:', isOpen);
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}

			console.log('Quicklinks Height:', this.quick_links_height);
		},

		getQuickLinksHeight() {
			// Access the element via its ref
			const element = this.$refs.quickLinks;

			// Check if the element exists
			if (element) {
				// Use getBoundingClientRect to get the height
				const height = element.getBoundingClientRect().height;

				// Alternatively, you can use offsetHeight
				// const height = element.offsetHeight;
				this.quick_links_height = height;
			} else {
				this.quick_links_height = 0;
			}
		},

		getWordsInFirstRow(paragraph) {
			const words = paragraph.trim().split(' ');

			const firstRowWords = [];
			const tempElement = document.createElement('span');
			document.body.appendChild(tempElement);

			for (const word of words) {
				tempElement.textContent = `${firstRowWords.join(' ')} ${word}`;

				if (tempElement.offsetTop !== firstRowWords.length) {
					break;
				}

				firstRowWords.push(word);
			}

			document.body.removeChild(tempElement);

			return firstRowWords;
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.standard_header {
	background-image: var(--background-image);
	background-size: cover;
	background-repeat: no-repeat;
	position: relative;
	background-position: center var(--content-bg-pos);

	&::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		pointer-events: none;
		background: rgba(#46370e, 0.35);
		z-index: 4;
	}

	@media (max-width: $mobile-xl) {
		min-height: 350px;
	}

	.container {
		min-height: 100%;
		position: relative;
		max-width: 100%;
		/* padding-left: calc((100% - 1440px) / 2);
		padding-right: 0; */
		z-index: 5;
		padding-top: 100px;
		padding-bottom: 100px;
		min-height: calc(550px - 200px);
		align-items: center;

		/* @media (min-width: $mobile-xl) {
			padding: 0 0 0 40px;
		} */

		/* @media (max-width: $mobile-xl) {
			min-height: 550px;
		} */
	}

	#breadcrumbs {
		grid-column: 3 / span 8;
		margin-bottom: 32px;

		.breadcrumb_container {
			display: flex;
			justify-content: center;

			> span {
				display: inline-flex;
				justify-content: center;
				align-items: center;

				@media only screen and (max-width: 768px) {
					&:first-child a {
						text-indent: -9999px;
						color: var(--white);

						&::before {
							content: '…';
							text-indent: 0;
						}
					}
				}

				span {
					font: normal normal normal 15px/20px
						var(--primary-font-family-heading);
					text-transform: uppercase;
					text-decoration: none;
					color: var(--white);

					&.breadcrumb_last {
						color: var(--white);
					}

					a {
						font: normal normal normal 15px/20px
							var(--primary-font-family-heading);
						text-transform: uppercase;
						text-decoration: none;
						color: var(--white);
					}

					strong {
						font: normal normal normal 15px/20px
							var(--primary-font-family-heading);
						text-transform: uppercase;
						text-decoration: none;
						color: var(--white);
					}

					&.divider {
						&::before {
							margin: 0 20px;
							display: inline-block;
							content: '';
							width: 4px;
							height: 4px;
							background: var(--white);
							border-radius: 50%;
							margin-bottom: 2px;
						}
					}

					&:last-child {
						a {
							font: normal normal bold 14px/20px var(--primary-font-family);
							text-transform: uppercase;
							text-decoration: none;
							color: var(--white);
						}
					}
				}
			}
		}
	}

	.inner {
		grid-column: 4 / span 6;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}

		h1 {
			text-align: center;
			text-transform: uppercase;
			font-weight: 500;
			color: white;
			margin-bottom: 32px;
		}

		.body {
			color: white;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/StandardHeader.vue